import { useWorkspace } from "./WorkspaceContext";
import { Kbd, Skeleton } from "@heroui/react";
import { Button } from "@heroui/react";

export default function WorkspaceSwitcher() {
  const { current, available } = useWorkspace();
  const hasAvailable = available?.length > 0;
  const label = current?.label ?? "Workspaces";
  return (
    <div className="relative inline-flex">
      <span className="pointer-events-none absolute -inset-5 rounded-full z-0">
        <span className="absolute inset-0 rounded-full border border-violet-500/85 bg-gradient-to-b from-violet-500/35 to-transparent animate-[expandOpacity_2.8s_ease-in-out_infinite] [animation-delay:-0.9s]" />
        <span className="absolute inset-0 rounded-full border border-violet-500/70 bg-gradient-to-b from-violet-500/28 to-transparent animate-[expandOpacity_3.4s_ease-in-out_infinite] [animation-delay:-1.4s]" />
        <span className="absolute inset-0 rounded-full border border-violet-500/55 bg-gradient-to-b from-violet-500/22 to-transparent animate-[expandOpacity_4s_ease-in-out_infinite] [animation-delay:-2.1s]" />
      </span>
      <Button
        type="button"
        color="default"
        variant="bordered"
        radius="full"
        size="sm"
        className="h-10 px-5 text-[13px] font-semibold bg-white/90 text-slate-900 border border-slate-400"
        onPress={() => window.dispatchEvent(new Event("open-command-palette"))}
        aria-label="Ouvrir la palette"
      >
        {hasAvailable ? (
          <>
            <span className="truncate max-w-[140px] text-primary">{label}</span>
            <Kbd
              className="text-[11px] bg-white text-slate-600 border-slate-200 leading-none"
              keys={["command"]}
            >
              K
            </Kbd>
          </>
        ) : (
          <>
            <Skeleton className="rounded-full w-4 h-4" />
            <span className="text-slate-400">Workspaces</span>
          </>
        )}
      </Button>
    </div>
  );
}
